document.addEventListener("DOMContentLoaded", () => {
  const marqueeContent = document.querySelector("ul.marquee-content");
  marqueeContent.dataset.marqueeItems = marqueeContent.children.length;
  updateMarquee();
});

function updateMarquee() {
  const marquee = document.querySelector(".marquee");
  const marqueeContent = document.querySelector("ul.marquee-content");
  const displayedCount = getComputedStyle(marquee).getPropertyValue(
    "--marquee-elements-displayed",
  );

  marquee.style.setProperty(
    "--marquee-elements",
    marqueeContent.children.length,
  );

  // Remove extra cloned elements
  while (marqueeContent.children.length > marqueeContent.dataset.marqueeItems) {
    marqueeContent.removeChild(marqueeContent.lastElementChild);
  }

  // Add cloned elements
  for (let i = 0; i < displayedCount; i++) {
    const clonedElement = marqueeContent.children[i].cloneNode(true);
    clonedElement.classList.add("cloned");
    marqueeContent.appendChild(clonedElement);
  }
}
